import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../../../common/html/element'
import { PortfolioList } from './PortfolioList'
import { selectSavedPortfolioList } from '../../popupRecommendationList/store/slice'
import { getSavedPortfolio } from '../../popupRecommendationList/store/thunk'
import { SearchName } from './SearchName'

export const SaveListContent = () => {
  const dispatch = useDispatch()

  const [textSearch, setTextSearch] = useState('')
  const savedPortfolioList = useSelector(selectSavedPortfolioList)

  useEffect(() => {
    dispatch(
      getSavedPortfolio({
        Sort: 'CreateDate',
        SortDirection: 'Descending',
        PageSize: 300,
      }),
    )
  }, [])

  return (
    <Element className="flexColumn flex1" style={{ padding: '12px 0' }}>
      <SearchName
        setTextSearch={setTextSearch}
        savedPortfolioList={savedPortfolioList}
      />
      <PortfolioList
        textSearch={textSearch}
        savedPortfolioList={savedPortfolioList}
      />
    </Element>
  )
}
